import { useEffect, useRef, useState } from 'react';
import TanoProjo from './TanoProjo';
import { FONT_TITRE } from '../../utils/qcmTheme';

const reducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

/**
 * Résultat de la question après révélation — LE moment fort, gradué :
 * count-up du % (rAF ease-out, recette du XpRecapOverlay), et Tano qui
 * danse (≥ 70 %), rebondit (≥ 50 %) ou encourage (idle, < 50 % — jamais de
 * mood triste projeté). Les confettis ≥ 70 % sont montés par ProjectionQCM.
 */
const ProjectionReveal = ({ pctCorrect, message, couleur, bonneReponse, animated }) => {
  const [pctAffiche, setPctAffiche] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (reducedMotion() || pctCorrect <= 0) {
      setPctAffiche(pctCorrect);
      return undefined;
    }
    const debut = performance.now();
    const DUREE = 900;
    const tick = (t) => {
      const p = Math.min(1, (t - debut) / DUREE);
      setPctAffiche(Math.round(pctCorrect * (1 - Math.pow(1 - p, 3)))); // ease-out cubic
      if (p < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [pctCorrect]);

  const tanoVariant = pctCorrect >= 70 ? 'danse' : 'entree';
  const tanoMood = pctCorrect >= 50 ? 'joy' : 'idle';

  return (
    <div className="mt-auto flex-shrink-0 px-9 pt-4 pb-6 bg-white/[0.06] text-white" style={{ borderTop: '1px solid rgba(255,255,255,.1)' }}>
      <div className="flex items-center gap-6 flex-wrap">
        <TanoProjo variant={tanoVariant} mood={tanoMood} size={96} />
        <p
          className="font-black tabular-nums transition-all duration-700"
          style={{
            color: couleur,
            fontSize: 'clamp(40px, 6vw, 72px)',
            fontFamily: FONT_TITRE,
            transform: animated ? 'scale(1)' : 'scale(.5)',
            opacity: animated ? 1 : 0,
            lineHeight: 1,
          }}
        >
          {pctAffiche}%
        </p>
        <div
          className="transition-all duration-500 delay-300"
          style={{ opacity: animated ? 1 : 0, transform: animated ? 'translateY(0)' : 'translateY(10px)' }}
        >
          <p className="text-sm font-semibold text-white/50">de bonnes réponses</p>
          <p className="font-black text-white" style={{ fontSize: 'clamp(18px, 2.4vw, 28px)', fontFamily: FONT_TITRE }}>
            {message}
          </p>
          {bonneReponse ? (
            <p className="text-[15px] font-semibold mt-0.5 text-white/50">
              Réponse : <span className="font-black text-emerald-400">{bonneReponse}</span>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProjectionReveal;
